<template>
    <v-form-item
        name="systemEvent"
        label="选择事件"
        required="请选择"
        @error="handlerError"
    >
        <div class="flex">
            <v-radio-group
                @change="change"
                v-model="radio"
            >
                <v-radio
                    v-for="(item, index) in dynamicySystemEvent"
                    :value="index + 1"
                    :key="index"
                    :disabled="isSystemItemEnable(index + 1)"
                    name="radio"
                >
                    {{ item }}
                    <v-icon
                        v-if="item === '服务评价'"
                        v-tip:statisfyTip.hover
                        name="input_question"
                        class="tip-icon"
                    />
                </v-radio>
            </v-radio-group>
        </div>

        <v-tip
            ref="statisfyTip"
            kind="small"
            placement="top"
        >
            如关闭满意度设置，该气泡将不展示。
        </v-tip>
    </v-form-item>
</template>

<script>
import { SYSTEMEVNT, SYSTEMEVNT_ECOMMERCE, ACTION_TYPE } from '../../constants';
import { getECommerceStatus } from '@/cgi/getECommerceStatus';
export default {
    name: 'Systemevent',
    props: {
        meta: {
            type: Object,
            default: () => ({}),
        },
        menu: {
            type: Object,
            default: () => ({}),
        },
        index: {
            type: Number,
            default: -1,
        },
    },
    data() {
        return {
            radio: undefined,
            // 支持的事件列表。
            dynamicySystemEvent: [...SYSTEMEVNT],
        };
    },

    async mounted() {
        // 检测是否有电商工具包。
        // 注意，如果后续加入mounted等周期函数，可能需要做相应调整
        if (await getECommerceStatus()) {
            this.dynamicySystemEvent = [...SYSTEMEVNT, ...SYSTEMEVNT_ECOMMERCE];
        }

        this.initRadio();
    },
    beforeDestroy() {
        // 组件将被卸载时，清空对应的错误。
        this.$emit('error', '');;
    },
    methods: {
        // 初始化radio
        initRadio() {
            let radio = this.meta.type;
            console.log('this.meta');
            if (radio) {
                for (const [index, value] of this.menu.list.entries()) {
                    if (index !== this.index && value.meta.type === radio && value.action === ACTION_TYPE.ACTION_SYSTEM) {
                        radio = undefined;
                        this.$emit('change', { type: radio });
                        break;
                    }
                }
            }
            if (!radio) {
                const existAction = [];
                this.menu.list.forEach((element) => {
                    if (element.action === ACTION_TYPE.ACTION_SYSTEM) {
                        existAction.push(element.meta.type);
                    }
                });
                for (const [index] of this.dynamicySystemEvent.entries()) {
                    if (existAction.indexOf(index + 1) === -1) {
                        radio = index + 1;
                        this.$emit('change', { type: radio });
                        break;
                    }
                }
            }

            this.radio = radio;
        },
        isSystemItemEnable(value) {
            for (const [i, element] of this.menu.list.entries()) {
                if (element.action === ACTION_TYPE.ACTION_SYSTEM) {
                    if (element.meta.type === value && i !== this.index) return true;
                }
            }
            return false;
        },
        change(val) {
            this.$emit('change', { type: val });
        },

        handlerError(msg) {
            this.$emit('error', msg);
        },
    },

};
</script>

<style lang="less" scoped>
.flex {
    display: flex;
    align-items: center;

    /deep/.v-radio-group{
        margin-top: 0 !important;
        .v-radio__label__text{
            display:inline-flex;
            align-items: center;

            .v-icon{
                margin-left: 6px;
            }
        }
    }

}
</style>
